import classNames from 'classnames';
import type { CSSProperties } from 'react';

import { css, keyframes } from '@sorare/css';

const growAnimation = keyframes`
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    20% {
        opacity: 1;
        transform: scale(1.15)
    }
    80% {
        opacity: 1;
        transform: scale(1.15)
    }
    100% {
      opacity: 0;
      transform: scale(0.8);
    }
`;
const blur = css`
  filter: blur(40px);
`;
const ellipse = css`
  width: 100%;
  aspect-ratio: var(--card-aspect-ratio);
  clip-path: ellipse(closest-side farthest-side);
  background: color-mix(in srgb, var(--color, #e5aff9) 40%, transparent);
  animation: ${growAnimation} 2s linear forwards;

  &.holo {
    background: linear-gradient(
      160deg,
      #ff0000 20%,
      #ff8000,
      #ffff00,
      #00ff00,
      #0000ff,
      #8000ff 80%
    );
  }
`;

type Props = { show: boolean; holo?: boolean; color?: Nullable<string> };
export const Glow = ({ show, holo, color }: Props) => {
  if (!show) return null;

  return (
    <div className={blur}>
      <div
        className={classNames(ellipse, { holo })}
        style={{ '--color': color } as CSSProperties}
      />
    </div>
  );
};
